import { request } from './http'
export function getContent(id) {
  return request({
    methods: 'post',
    url: '/api/agreement/detail',
    params: { id },
  })
}
